import React from "react";
import { RouteComponentProps } from "@reach/router";
import { Grid, Typography } from "@material-ui/core";
import { Viewer } from "components/auth/types";
import PropertyForm from "./property-form";

const NewProperty: React.FC<RouteComponentProps<{viewer: Viewer}>> = () => <Grid>
  <Typography variant="h5">Add New Property</Typography>
  <PropertyForm submitForm={(values) => console.log("added", values)}/>
</Grid>;

export default NewProperty;
